import { render, staticRenderFns } from "./ChatGPTBlacklist.vue?vue&type=template&id=d367eac2&scoped=true&"
import script from "./ChatGPTBlacklist.vue?vue&type=script&lang=js&"
export * from "./ChatGPTBlacklist.vue?vue&type=script&lang=js&"
import style0 from "./ChatGPTBlacklist.vue?vue&type=style&index=0&id=d367eac2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d367eac2",
  null
  
)

export default component.exports